import { useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { userSelectors } from 'store/features/user/selectors'
import {
  getResizeImageModel,
  getSourceImageModel
} from 'store/features/aiAvatar/utils'
import { AVATAR_RESIZE_EXCLUDED_ASPECT_RATIOS } from 'store/features/aiAvatar/consts'

// Reads the aiImage model backing the source-image ENHANCE op (matched by
// AVATAR_SOURCE_IMAGE_MODEL_CODE) and derives its CTA credit cost. Cost is 0
// when the user's plan has that model unlimited, mirroring the AI Image
// footer's cost logic. Returns cost 0 until the models catalog is loaded (the
// Avatar tab dispatches getModels on mount).
export const useSourceImageModel = () => {
  const modelsData = useSelector(aiImageSelectors.modelsData)
  const unlimitedIds = useSelector(userSelectors.unlimitedAiImageModelIds)

  const model = getSourceImageModel(modelsData)
  const isUnlimited = !!model && !!unlimitedIds?.includes(model.id)

  return {
    cost: isUnlimited ? 0 : (model?.cost ?? 0)
  }
}

// Reads the aiImage model backing the source-image RESIZE op — the avatar
// resize-default (`isDefaultFor: 'resize-image-avatar'`), i.e. the exact
// model recommendation-api's decideImageModel will pick for /gen-ai/resize-image
// — and derives the ratio menu + CTA credit cost from IT, so the badge always
// matches the actual charge. Returns empty ratios / cost 0 until the models
// catalog is loaded; ResizeAvatarButton tolerates the empty list via its
// defaultRatio fallback.
export const useResizeImageModel = () => {
  const modelsData = useSelector(aiImageSelectors.modelsData)
  const unlimitedIds = useSelector(userSelectors.unlimitedAiImageModelIds)

  const model = getResizeImageModel(modelsData)
  const isUnlimited = !!model && !!unlimitedIds?.includes(model.id)

  return {
    // The menu IS the model's own ratio list (reco validates against the same
    // list, so menu ⊆ backend-accepted by construction), minus the exclusions
    // ('auto' + icon-less ratios — see the const's comment).
    aspectRatios: (model?.possibleAspectRatios ?? []).filter(
      ratio => !AVATAR_RESIZE_EXCLUDED_ASPECT_RATIOS.includes(ratio)
    ),
    cost: isUnlimited ? 0 : (model?.cost ?? 0)
  }
}
